import signalr from 'BASE/common/signalrAdapter';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component'; //權限等狀態初始化須使用
import BetAwardNotifyComponent from 'BASE/components/notification/betAwardNotify.component';
import { offAllInput } from 'BASE/plugins/autoCompletePlugin';
import StreamingNotificationComponent from 'DD/views/Notification/StreamingNotification.vue';

export default {
    mixins: [websiteInfoUtil, userInfo_component],
    components: {
        BetAwardNotifyComponent,
        StreamingNotificationComponent,
    },
    data: function () {
        return {
            appClass: '',
            notificationCount: 1,                        
        }
    },
    computed:{
        skinClass(){
            if(!this.CanUseSkin){
                return '';
            }
            return this.$store.state.userinfo.skinClass;
        },

        CanUseSkin(){
            let val = this.$route.name;
            let _skinHandle = ['Home','Bet','BetInput'];

            if( val != null && _skinHandle.find((item) => val==item )){
                return true;
            }
            return false;
        },

    },
    watch: {
        "$route.path": function (val, oldVal) {
            // 投注頁body使用特定class
            let _betBackgroundClass = ['/Bet','/ComboBet'];
            if(_betBackgroundClass.find((item) => val.indexOf(item) != -1)){
                document.body.className = "betbg";
            }
            else if(val.indexOf('/Predict') != -1) {
                document.body.className = "betbg coinMain";
            }
            else {
                document.body.className = "";
            }
        },
    },
    methods:{
        IEBrowserAlert(){
            let _this = this;
            if (window.document.documentMode) {
                _this.$dialog.get("ieAlert").show();
            }
        }
    },
    created() {
        let _this = this;
        signalr.init();
        window.addEventListener("load", function(){
            _this.IEBrowserAlert();
        });
    },
    updated(){
        this.$nextTick(function () {
            // 關閉當下所有input的自動填入，減少大部分瀏覽器自動填入狀況，剩下部分手動使用autoCompletePlugin排除
            offAllInput(this.$el);
        });        
    },
};